// @flow
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import ItemCartContainer from '../../containers/ItemCartContainer';
import {Desktop, UntilTablet} from '../../../../utils/responsive';
import {postForecastClassicPriceApi, postForecastDiyPriceApi} from '../../../new-order/QuoteStep/api';
import {Link} from 'react-router-dom';
import {CommaFormat} from '../../../../elements/Price/Price';
import SummaryModal from "../../../new-order/ProductStep/components/NewProductForm/QuoteBox/SummaryModal/SummaryModal";

import iconImage from '../../../../assets/img/shopping-cart/qempo-full-active.png';
import qempoLiteActiveImage from '../../../../assets/img/shopping-cart/qempo-lite-active.png';

import style from './QempoLiteContent.scss';

import type {ShoppingCartItem} from '../../../../entities';
import type {ForecastCourier, ForecastType, Forecast, ForecastTier} from '../../../new-order/QuoteStep/api';

type Props = {
  subtype: string;
  items?: ShoppingCartItem[];
  isFetchingShoppingCart?: boolean;
  isDeletingItem?: boolean;
  isEditingItem?: boolean;
  fetchCheckoutDataSuccess: (forecast: Forecast, selectedIndex: number,
                             importMethod: ForecastType, shoppingCartItems?: ShoppingCartItem[]) => void;
};

type State = {
  forecastCourier?: ForecastCourier;
  forecastCouriers?: ForecastCourier[];
  isLoadingForecast: boolean;
  summaryOpen: boolean;
};


export default class QempoLiteContentRoot extends Component<Props, State> {
  state: State = {
    isLoadingForecast: false,
    summaryOpen: false,
  };

  componentDidMount() {
    const {items, subtype} = this.props;

    if (items) {
      this.forecastData(items, subtype);
    }
  }

  componentDidUpdate(prevProps: Props) {
    const {items, subtype} = this.props;

    if (
      (prevProps.items && items) &&
      (
        (prevProps.items.length !== items.length) ||
        (
          prevProps.items.length === items.length &&
          items.some((i, idx) => i.amount !== (prevProps.items: any)[idx].amount)
        )
      )
    ) {
      this.forecastData(items, subtype);
    }
  }

  forecastData(items: ShoppingCartItem[], subtype: string) {
    const itemsReq: { [key: string]: any }[] = items.map((item) => {
      const itemReq: { [key: string]: any } = {
        url: item.url,
        name: item.name,
        categoryId: parseInt(item.itemCategoryId, 10),
        price: item.price,
        amount: item.amount,
        originalPackaging: item.originalPackaging,
        shipping: item.shipping,
      };

      if (item.volumeTier) itemReq.volumeTier = item.volumeTier.code;
      if (item.weight) itemReq.weight = item.weight;

      return itemReq;
    });

    const req = {
      deliveryCountry: 'PE',
      purchaseCountry: 'US',
      items: itemsReq,
    };

    this.setState({isLoadingForecast: true}, () => {
      postForecastDiyPriceApi(req).toPromise().then((forecast: ForecastCourier[]) => {
        const forecastCourier = forecast.find((f) => f.courier.id === subtype);
        this.setState({isLoadingForecast: false, forecastCourier, forecastCouriers: forecast});
      });
    });
  }

  handleClick = () => {
    const {items, fetchCheckoutDataSuccess} = this.props;
    const {forecastCourier} = this.state;

    const forecastDIY: Forecast = {
      DIY: forecastCourier ? [forecastCourier] : [],
      CLASSIC: []
    };

    fetchCheckoutDataSuccess(forecastDIY, 0, 'DIY', items);
  };

  render() {
    const {subtype, items, isFetchingShoppingCart, isDeletingItem, isEditingItem} = this.props;
    const {isLoadingForecast, forecastCourier, summaryOpen} = this.state;
    
    let daysText = '';
    
    if (forecastCourier) {
      daysText = forecastCourier.days;
      
      if (items && items.length > 0 && items.some(x => x.itemCategoryId === 3)) {
        daysText = `${forecastCourier.days} - 60`;
      }
    }

    return (
      <Fragment>
        <div
          className={`${style.qempoLiteContentRoot} ${(isFetchingShoppingCart || isDeletingItem || isLoadingForecast || isEditingItem) ? style.isLoading : ''}`}>
          <button className={style.headerWrap}>
            <div className={style.headerContent}>
              <img
                src={qempoLiteActiveImage}
                alt="Qempo Lite"
              />
              <div>
              <span className={style.active}>
                {`Qempo Lite - ${items && items.length > 0 ? items[0].courier.name : ''}`}
              </span>
                <span className={style.header}>
                Realiza la compra del producto y envíalo a nuestra direción en USA
              </span>
              </div>
            </div>
            <div className={style.deliveryDate}>
              <h6>{`Recíbelo ${daysText} días después de la entrega en USA`}</h6>
            </div>
          </button>

          {items && items.map((item: ShoppingCartItem, index: number) => (
            <ItemCartContainer
              key={`item-cart-${index}`}
              item={item}
              type="LITE"
            />
          ))}
          <div className={style.subtotalWrap}>
            <div className={style.subtotalContent}>
              <button onClick={() => this.setState({summaryOpen: true})}
                      className={style.seeSummary}>Ver detalle
              </button>
              <Link className={style.buttonPayment} to="/new-order/checkout/items" onClick={this.handleClick}>
                <div className={style.leftWrap}>
                  <h6>Ir a pagar</h6>
                </div>
                <div className={style.priceWrap}>$ {forecastCourier ?
                  <CommaFormat price={forecastCourier.total}/> : '??.??'}</div>
              </Link>
              <span>Solo pagas el envío.</span>
            </div>
          </div>
        </div>
        {forecastCourier && (
          <SummaryModal isOpen={summaryOpen}
                        handleClose={() => this.setState({summaryOpen: false})}
                        forecastCouriers={[forecastCourier]}
                        methodType="LITE"
                        liteSubtype={forecastCourier.courier.id}
          />
        )}
      </Fragment>
    );
  }
}

QempoLiteContentRoot.propTypes = {
  subtype: PropTypes.string.isRequired,
  items: PropTypes.array,
  isFetchingShoppingCart: PropTypes.bool,
  isDeletingItem: PropTypes.bool,
  isEditingItem: PropTypes.bool,
  fetchCheckoutDataSuccess: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/shopping-cart/components/QempoLiteContent/QempoLiteContent.jsx